<template>
  <div class="container">
    <div class="modal-container">
        <div class="header">
          <ion-text class="title">このアカウントは ロックされています</ion-text>
        </div>

        <div class="content">
          <div>
            <p>
              <ion-text>
                正しくないパスワードが連続して入力されたため、このアカウントは一時的にロックされています。
                <br />
                しばらく時間をあけて、正しいパスワードを入力してください。
              </ion-text>
            </p>
          </div>
          <div class="close-button-container">
            <ion-button class="close-button" expand="block" @click="closeModal">閉じる</ion-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { IonButton, IonContent, IonToolbar, IonText} from '@ionic/vue'
  import { useRouter } from 'vue-router'
  import { onBeforeMount } from 'vue';

  const emit = defineEmits(['closeAccountLockModal']);

  function closeModal() {
    emit('closeAccountLockModal');
  }

</script>

<style scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);

  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  width: 80%;
  background-color: white;
  border-radius: 10px;
}

.header {
  background-color: #D7001C;
  border-radius: 10px 10px 0px 0px;
  color: white;

  padding: 10px 20% 10px 20%;
  text-align: center
}

.content {
  padding: 0px 10% 30px 10%;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.content-text {
  font-size: 12px;
  text-align: left;
}

.close-button {
  --ion-color-base: #D7001C;
  margin: auto;
  width: 60%;
}
</style>
